import BottomControls from './bottom-controls';

export default BottomControls;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/BottomControls/index.js